/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconAries: {
  name: 'aries';
  data: string;
} = {
  name: 'aries',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M413.02 62.835c-51.416 24.761-85.761 78.852-108.478 144.334-22.722-65.482-57.073-119.573-108.483-144.334C31.417-16.475-31.644 210.996 90.28 307.62h101.17s-29.973-52.493-33.482-59.928c-5.38-11.356-37.032-93.526 7.748-64.596 60.588 39.14 74.422 178.853 81.035 240.333 6.648 61.874 10.51 143.581 10.51 143.581H351.824s3.862-81.707 10.516-143.581c6.613-61.475 20.447-201.193 81.03-240.333 44.786-28.93 13.122 53.246 7.754 64.596-3.515 7.435-33.488 59.928-33.488 59.928H518.8c121.924-96.624 58.863-324.089-105.78-244.785z"/></svg>`,
};
